<template>
  <div>
    <b-icon :icon="icon" />
  </div>
</template>

<script>
export default {
  name: 'CustomIcon',
  props: {
    icon: {
      type: String,
      default: '',
      meta: {
        description: 'Propiedad icono personalizada.',
        example: 'search',
      },
    },
  },
};
</script>

<style lang="scss" scoped></style>
